import axios from 'axios';

if (!import.meta.env.VITE_APP_SPECIES_INFO_URL) {
  throw new Error('ABMI API Env not set: VITE_APP_SPECIES_INFO_URL');
}

const abmiApiUrl = import.meta.env.VITE_APP_SPECIES_INFO_URL;

const abmiAxios = axios.create({
  baseURL: abmiApiUrl
});

export async function getAllSpecies (path: any) {
  const columnMaps: Record<string, string> = {
    cname: 'CommonName',
    sname: 'name',
    status: 'SpeciesStatus'
  };
  const apiFct = `?@ancestor=${path}&"SpeciesStatus"[ne]=null&"SpeciesStatus"[ne]="0"`;
  try {
    const response = await abmiAxios.get(apiFct);
    const data = response.data;
    /* re map column names */
    const newData = data.results.map((speciesRow: Record<string, any>) => {
      const row:Record<string, string> = {};
      Object.keys(columnMaps).forEach(k => {
        row[k] = speciesRow[columnMaps[k]];
      });
      return row;
    });
    return newData;
  } catch (error) {
    return (error);
  }
}

const abmiApi = {
  getAllSpecies
};

export default abmiApi;
